<template>
    <div class="c-box p-5">
        <div class="c-box__header mb-5">
            <div class="c-box__title text-center text-uppercase">
                Password Reset
            </div>
        </div>
        <template v-if="reset_sent === true">
            <div class="alert alert-info">
                <p>Your password has been reset!</p>
              <router-link :to="{ name: 'login.main', params: { company_id: c_id } }" class="c-btn c-btn--success">
                Sign In
              </router-link>
            </div>
        </template>
        <template v-else>
            <div class="c-form">
                <form @submit.prevent="reset_pass">
                    <div class="row form-group c-form__group">
                        <label for="cId" class="col-12 c-form__label">Panel ID</label>

                        <div class="col-12">
                            <b-form-input id="cId" placeholder="Enter id" v-model.trim="c_id" disabled="true"></b-form-input>
                        </div>
                    </div>
                  <div class="row form-group c-form__group">

                    <div class="col-5">
                      <label for="new_pass" class="c-form__label">New password</label>

                      <b-form-input type="password" id="new_pass" v-model="new_pass"></b-form-input>

                      <label for="repeat_pass" class="c-form__label">Confirm password</label>

                      <b-form-input type="password" id="repeat_pass" v-model="repeat_pass"></b-form-input>
                    </div>

                    <div class="col-7">
                      <p class="form-text text-muted">
                        New password must meet the following requirements:
                      </p>
                      <ul class="form-text text-muted">
                        <li> must be at least 8 characters long</li>
                        <li> must contain at least one lower case letter</li>
                        <li> must contain at least one upper case letter</li>
                        <li> must contain at least one number</li>
                        <li> must contain a special character</li>
                      </ul>
                    </div>

                  </div>
                    <div class="row form-group c-form__group">
                        <div class="col-md-offset-2 col-12">
                            <button v-if="reset_pass_in_progress === false" class="c-btn c-btn--success">
                                Reset password
                            </button>
                            <button v-else disabled class="c-btn c-btn-default js--btn-loading-modal">
                                Loading...
                            </button>
                            <router-link :to="{ name: 'login.main', params: { company_id: c_id } }" class="c-btn c-btn-default">
                                Sign In
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </template>
        <reset-password-main-ccs-modal></reset-password-main-ccs-modal>
    </div>
</template>

<script>
import CcsModal from "@/components/CcsModal.vue";

export default {
    metaInfo: {
        title: "Login"
    },

    components: {
        ResetPasswordMainCcsModal: CcsModal
    },

    mounted() {},

    props: {
        company_id: {
            type: String,
            default: ""
        },
        reset_token: {
            type: String,
            default: ""
        }
    },

    data: function() {
        return {
            reset_pass_in_progress: false,
            reset_sent: false,

            c_id: this.company_id,
            new_pass: "",
            repeat_pass: ""
        };
    },

    watch: {},

    computed: {},

    methods: {
        reset_pass: function() {
            if (this.c_id === undefined || this.c_id === "" || Number.isInteger(parseInt(this.c_id)) === false) {
                this.$modal.show("forgot-password-main-ccs-modal-dialog", {
                    type: "error",
                    title: "Error while attempting to login",
                    text: "Please fill in the Panel ID field",
                    buttons: [
                        {
                            title: "Close",
                            default: false // Will be triggered by default if 'Enter' pressed.
                        }
                    ]
                });

                return;
            }

            let payload = {
                company_id: this.c_id,
                reset_token: this.reset_token,
                new_pass: this.new_pass,
                repeat_pass: this.repeat_pass
            };

            this.reset_pass_in_progress = true;
            this.$store.dispatch("user/ResetPassword", payload).then(
                (success_data) => {
                    this.reset_pass_in_progress = false;
                    this.reset_sent = true;
                },
                (error_data) => {
                    this.reset_pass_in_progress = false;
                    this.$modal.show("reset-password-main-ccs-modal-dialog", {
                        type: "error",
                        title: "Could not send reset password request",
                        text: error_data,
                        buttons: [
                            {
                                title: "Close",
                                default: true // Will be triggered by default if 'Enter' pressed.
                            }
                        ]
                    });
                    return;
                }
            );
        }
    }
};
</script>
